import { ProductSpecInfoModal } from '@app/entities/Product';
import { ProductSpecCode } from '@app/entities/Product/module/types/productSchema';
import classNames from 'classnames';
import { ReactNode } from 'react';

import styles from './sideFilterElementTitle.module.scss';

interface SideFilterElementTitleProps {
  children: ReactNode;
  isInfoTooltip?: boolean;
  nameTooltip?: ProductSpecCode | string;
  bold?: boolean;
  className?: string;
}

export const SideFilterElementTitle = ({ children, isInfoTooltip, nameTooltip, bold, className }: SideFilterElementTitleProps) => {
  if (!children) {
    return null;
  }
  return (
    <div className={classNames(styles.Header, { [styles.Bold]: bold }, className)}>
      <span className={styles.Label}>
        {children}
        {isInfoTooltip && (
          <span className={styles.Info} data-testid={`info-badge-${nameTooltip}`}>
            <ProductSpecInfoModal type={nameTooltip} />
          </span>
        )}
      </span>
    </div>
  );
};
